// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__mb2ku","body":"Layout_body__hjYkF","logo":"Layout_logo__JHeI4","links":"Layout_links__4i-8w","link_active":"Layout_link_active__sudny"};